<template>
  <div>
    <v-layout row wrap class="mb-4">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-card>
      <v-card-title>
        <div>
          <h3 class="headline mb-0">{{labels.shipment}}</h3>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.convy" v-model="cargoForm.convy" :label="labels.convy" item-text="label" item-value="value" data-vv-name="convy" :data-vv-as="labels.convy" :error-messages="errors.collect('convy')" v-validate="'required'" :loading="convyLoading"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field :label="labels.lcNo" v-model="cargoForm.lcNo" :error-messages="errors.collect('lcNo')" data-vv-name="lcNo" :data-vv-as="labels.lcNo" v-validate="'max:20|entry'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.vessel.data" v-model="cargoForm.vesNo" :label="labels.vesNo" item-text="label" item-value="value" data-vv-name="vesNo" :data-vv-as="labels.vesNo" :error-messages="errors.collect('vesNo')" @input="doVessel" :hint="$parent.getVesselTonnageLabel(vesselParam.grt, vesselParam.nrt)" :persistent-hint="true" :loading="vesselLoading" clearable></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.voyage" v-model="cargoForm.voyNo" :label="cargoForm.vesNo? labels.voyNoMand:labels.voyNo" item-text="label" item-value="value" data-vv-name="voyNo" :data-vv-as="labels.voyNo" :error-messages="errors.collect('voyNo')" v-validate="voyageMandatory" :loading="voyageLoading" clearable></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.voyDateType" v-model="cargoForm.voyDateType" :label="labels.voyDateType" item-text="label" item-value="value" data-vv-name="voyDateType" :data-vv-as="labels.voyDateType" :error-messages="errors.collect('voyDateType')" v-validate="'required'" :loading="voyDateTypeLoading"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <cal-picker v-model="cargoForm.voyDate" :label="labels.voyDate" :data-vv-as="labels.voyDate" data-vv-name="voyDate" :error-messages="errors.collect('voyDate')"></cal-picker>
            </v-flex>
            <v-flex lg12 xs12>
              <v-autocomplete :items="quoteParam.voyArea" v-model="cargoForm.voyArea" :label="labels.voyArea" item-text="label" item-value="value" data-vv-name="voyArea" :data-vv-as="labels.voyArea" :error-messages="errors.collect('voyArea')" v-validate="'required'" :loading="voyAreaLoading"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.ports" v-model="cargoForm.portFrom" :label="labels.portFrom" item-text="label" item-value="value" data-vv-name="portFrom" :data-vv-as="labels.portFrom" :error-messages="errors.collect('portFrom')" :loading="portLoading"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.ports" v-model="cargoForm.portTo" :label="labels.portTo" item-text="label" item-value="value" data-vv-name="portTo" :data-vv-as="labels.portTo" :error-messages="errors.collect('portTo')" :loading="portLoading"></v-autocomplete>
            </v-flex>
            <v-flex lg12 xs12>
              <v-text-field :label="labels.voyDesc" v-model="cargoForm.voyDesc" :error-messages="errors.collect('voyDesc')" data-vv-name="voyDesc" :data-vv-as="labels.voyDesc" v-validate="'max:120|entry'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.surveySettlingAgts" v-model="cargoForm.surveyAgt" :label="labels.surveyAgt" item-text="label" item-value="value" data-vv-name="surveyAgt" :data-vv-as="labels.surveyAgt" :error-messages="errors.collect('surveyAgt')" :loading="surveyAgtLoading"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.surveySettlingAgts" v-model="cargoForm.settlingAgt" :label="labels.settlingAgt" item-text="label" item-value="value" data-vv-name="settlingAgt" :data-vv-as="labels.settlingAgt" :error-messages="errors.collect('settlingAgt')" :loading="settlingAgtLoading"></v-autocomplete>
            </v-flex>
            <v-flex lg12 xs12>
              <v-text-field :label="labels.clmPayAt" v-model="cargoForm.clmPayAt" :error-messages="errors.collect('clmPayAt')" data-vv-name="clmPayAt" :data-vv-as="labels.clmPayAt" v-validate="'max:120|entry'"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card class="mt-3">
      <v-card-title>
        <div>
          <h3 class="headline mb-0">{{labels.consignee}}</h3>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field :label="labels.csgnName" v-model="cargoForm.csgnName" :error-messages="errors.collect('csgnName')" data-vv-name="csgnName" :data-vv-as="labels.csgnName" v-validate="'max:60|entry'"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field :label="labels.csgnAdd1" v-model="cargoForm.csgnAdd1" :error-messages="errors.collect('csgnAdd1')" data-vv-name="csgnAdd1" :data-vv-as="labels.csgnAdd1" v-validate="'max:100|entry'"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field :label="labels.csgnAdd2" v-model="cargoForm.csgnAdd2" :error-messages="errors.collect('csgnAdd2')" data-vv-name="csgnAdd2" :data-vv-as="labels.csgnAdd2" v-validate="'max:100|entry'"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field :label="labels.csgnAdd3" v-model="cargoForm.csgnAdd3" :error-messages="errors.collect('csgnAdd3')" data-vv-name="csgnAdd3" :data-vv-as="labels.csgnAdd3" v-validate="'max:100|entry'"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field :label="labels.csgnAdd4" v-model="cargoForm.csgnAdd4" :error-messages="errors.collect('csgnAdd4')" data-vv-name="csgnAdd4" :data-vv-as="labels.csgnAdd4" v-validate="'max:100|entry'"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-layout row wrap class="pt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed" :disabled="proceedLoading">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_CARGO_PARAM, QUOTE_CARGO_PARAM_VESSEL, QUOTE_CARGO_PARAM_SHIPMENT, QUOTE_CARGO_SHIPMENT } from '@/store/types'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'

export default {
  data() {
    return {
      labels: {
        shipment: 'Shipment',
        consignee: 'Consignee',
        convy: 'Conveyance*',
        lcNo: 'Letter of Credit No.',
        vesNo: 'Vessel No.',
        vesNoMand: 'Vessel No.*',
        vesselTonnages: 'GRT/NRT',
        voyNo: 'Voyage No.',
        voyNoMand: 'Voyage No.*',
        voyDateType: 'Voyage Date Type*',
        voyDate: 'Voyage Date',
        voyArea: 'Voyage Code*',
        portFrom: 'Voyage From',
        portTo: 'Voyage To',
        voyDesc: 'Voyage Description',
        surveyAgt: 'Survey Agent',
        settlingAgt: 'Settling Agent',
        clmPayAt: 'Claims Payable At',
        csgnName: 'Name',
        csgnAdd1: 'Address Line 1',
        csgnAdd2: 'Address Line 2',
        csgnAdd3: 'Address Line 3',
        csgnAdd4: 'Address Line 4'
      },
      cargoForm: {
        convy: undefined,
        lcNo: undefined,
        vesNo: undefined,
        voyNo: undefined,
        voyDateType: undefined,
        voyDate: undefined,
        voyArea: undefined,
        portFrom: undefined,
        portTo: undefined,
        voyDesc: undefined,
        surveyAgt: undefined,
        settlingAgt: undefined,
        clmPayAt: undefined,
        csgnName: undefined,
        csgnAdd1: undefined,
        csgnAdd2: undefined,
        csgnAdd3: undefined,
        csgnAdd4: undefined
      },
      convyLoading: false,
      vesselLoading: false,
      voyageLoading: false,
      voyDateTypeLoading: false,
      voyAreaLoading: false,
      portLoading: false,
      surveyAgtLoading: false,
      settlingAgtLoading: false
    }
  },
  computed: {
    quoteParam() {
      return this.$store.state.agency.quotation.cargoParam
    },
    globalForm() {
      return this.$store.state.agency.quotation.cargoForm
    },
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    vesselParam() {
      if (this.quoteParam.vessel.data && this.quoteParam.vessel.data.length > 0 && this.cargoForm.vesNo) {
        const vesselParam = this.quoteParam.vessel.data.filter(param => param.value === this.cargoForm.vesNo)
        if (vesselParam && vesselParam.length > 0) {
          return vesselParam[0]
        } else {
          return {
            grt: 0,
            nrt: 0
          }
        }
      } else {
        return {
          grt: 0,
          nrt: 0
        }
      }
    },
    proceedLoading() {
      if (this.convyLoading || this.vesselLoading || this.voyageLoading || this.voyDateTypeLoading || this.voyAreaLoading || this.portLoading || this.surveyAgtLoading || this.settlingAgtLoading) {
        return true
      } else {
        return false
      }
    },
    voyageMandatory() {
      let result = ''
      if (this.cargoForm.vesNo) {
        result = 'required'
      }
      return result
    }
  },
  methods: {
    async doInit() {
      // Default value from vuex store 1st
      this.cargoForm.convy = this.globalForm.convy
      this.cargoForm.lcNo = this.globalForm.lcNo
      this.cargoForm.vesNo = this.globalForm.vesNo
      this.cargoForm.voyNo = this.globalForm.voyNo
      this.cargoForm.voyDateType = this.globalForm.voyDateType
      this.cargoForm.voyDate = this.globalForm.voyDate
      this.cargoForm.voyArea = this.globalForm.voyArea
      this.cargoForm.portFrom = this.globalForm.portFrom
      this.cargoForm.portTo = this.globalForm.portTo
      this.cargoForm.voyDateType = this.globalForm.voyDateType
      this.cargoForm.voyDate = this.globalForm.voyDate
      this.cargoForm.voyArea = this.globalForm.voyArea
      this.cargoForm.portFrom = this.globalForm.portFrom
      this.cargoForm.portTo = this.globalForm.portTo
      this.cargoForm.voyDesc = this.globalForm.voyDesc
      this.cargoForm.surveyAgt = this.globalForm.surveyAgt
      this.cargoForm.settlingAgt = this.globalForm.settlingAgt
      this.cargoForm.clmPayAt = this.globalForm.clmPayAt
      this.cargoForm.csgnName = this.globalForm.csgnName
      this.cargoForm.csgnAdd1 = this.globalForm.csgnAdd1
      this.cargoForm.csgnAdd2 = this.globalForm.csgnAdd2
      this.cargoForm.csgnAdd3 = this.globalForm.csgnAdd3
      this.cargoForm.csgnAdd4 = this.globalForm.csgnAdd4

      if (!this.quoteParam.shipmentLoaded) {
        this.getConvy()
        this.getVoyDateType()
        this.getVoyArea()
        this.getPort()
        this.getSurveyAndSettlingAgents()
        await this.getVessel()
        if (this.cargoForm.vesNo) {
          this.doVessel()
        }
        this.$store.commit(QUOTE_CARGO_PARAM_SHIPMENT, true)
      }
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    async getConvy() {
      const apiURI = this.$store.state.agency.quotation.menu.convy
      if (apiURI) {
        this.convyLoading = true
        try {
          const result = await this.$http.get(apiURI)
          if (result.data) {
            const { data } = result
            const commitResult = {
              convy: data.data
            }
            this.$store.commit(QUOTE_CARGO_PARAM, commitResult)
            this.convyLoading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.convyLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getVessel() {
      const apiURI = this.$store.state.agency.quotation.menu.vessel
      if (apiURI) {
        this.vesselLoading = true
        try {
          const result = await this.$http.get(apiURI)
          if (result.data) {
            const { data } = result
            const menu = extractMenu(data._links)
            Object.assign(data, {
              menu: menu
            })
            this.$store.commit(QUOTE_CARGO_PARAM_VESSEL, data)
            this.vesselLoading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.vesselLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doVessel() {
      this.getVoyage()
    },
    async getVoyage() {
      const apiURI = this.quoteParam.vessel.menu.voyage
      if (apiURI) {
        this.voyageLoading = true
        try {
          const expand = {
            vesNo: this.cargoForm.vesNo
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              voyage: data.data
            }
            this.$store.commit(QUOTE_CARGO_PARAM, commitResult)
            this.voyageLoading = false

            // Check if the current model value is still valid
            if (this.cargoForm.voyNo && this.quoteParam.voyage && this.quoteParam.voyage.length > 0) {
              const validVoyage = this.quoteParam.voyage.filter(voyage => voyage.value === this.cargoForm.voyNo)

              // Invalid voyage (reset to undefined)
              if (!validVoyage || validVoyage.length === 0) {
                this.cargoForm.voyNo = undefined
              }
            } else {
              this.cargoForm.voyNo = undefined
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.voyageLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getVoyDateType() {
      const apiURI = this.$store.state.agency.quotation.menu.voyDateType
      if (apiURI) {
        this.voyDateTypeLoading = true
        try {
          const result = await this.$http.get(apiURI)
          if (result.data) {
            const { data } = result
            const commitResult = {
              voyDateType: data.data
            }
            this.$store.commit(QUOTE_CARGO_PARAM, commitResult)
            this.voyDateTypeLoading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.voyDateTypeLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getVoyArea() {
      const apiURI = this.$store.state.agency.quotation.menu.voyArea
      if (apiURI) {
        this.voyAreaLoading = true
        try {
          const result = await this.$http.get(apiURI)
          if (result.data) {
            const { data } = result
            const commitResult = {
              voyArea: data.data
            }
            this.$store.commit(QUOTE_CARGO_PARAM, commitResult)
            this.voyAreaLoading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.voyAreaLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getPort() {
      const apiURI = this.$store.state.agency.quotation.menu.port
      if (apiURI) {
        this.portLoading = true
        try {
          const result = await this.$http.get(apiURI)
          if (result.data) {
            const { data } = result
            const commitResult = {
              ports: data.data
            }
            this.$store.commit(QUOTE_CARGO_PARAM, commitResult)
            this.portLoading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.portLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getSurveyAndSettlingAgents() {
      const apiURI = this.$store.state.agency.quotation.menu.surveySettlingAgt
      if (apiURI) {
        try {
          this.surveyAgtLoading = true
          this.settlingAgtLoading = true
          const tempAcceptDate = this.formatDate(this.globalCommonForm.acceptDate)
          const expand = {
            effDate: tempAcceptDate
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              surveySettlingAgts: data.data
            }
            this.$store.commit(QUOTE_CARGO_PARAM, commitResult)
            this.surveyAgtLoading = false
            this.settlingAgtLoading = false

            if (this.cargoForm.surveyAgt && this.quoteParam.surveySettlingAgts && this.quoteParam.surveySettlingAgts.length > 0) {
              // Check if the current survey agent value is still valid
              let surveyAgtIsValid = false
              for (var i = 0; i < this.quoteParam.surveySettlingAgts.length; i++) {
                const surveyAgt = this.quoteParam.surveySettlingAgts[i]
                if (surveyAgt.value === this.cargoForm.surveyAgt) {
                  surveyAgtIsValid = true
                  break
                }
              }
              // Invalid Survey Agent (reset to undefined)
              if (!surveyAgtIsValid) {
                this.cargoForm.surveyAgt = undefined
              }
            }
            if (this.cargoForm.settlingAgt && this.quoteParam.surveySettlingAgts && this.quoteParam.surveySettlingAgts.length > 0) {
              // Check if the current settling agent value is still valid
              let settlingAgtIsValid = false
              for (var j = 0; j < this.quoteParam.surveySettlingAgts.length; j++) {
                const settlingAgt = this.quoteParam.surveySettlingAgts[j]
                if (settlingAgt.value === this.cargoForm.settlingAgt) {
                  settlingAgtIsValid = true
                  break
                }
              }
              // Invalid Settling Agent (reset to undefined)
              if (!settlingAgtIsValid) {
                this.cargoForm.settlingAgt = undefined
              }
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.surveyAgtLoading = false
          this.settlingAgtLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 1)
      this.$router.push({ name: 'cargoQuote' })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        this.$store.commit(QUOTE_CARGO_SHIPMENT, this.cargoForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit(QUOTE_CARGO_SHIPMENT, this.cargoForm)
          this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
          this.$router.push({ name: 'cargoQuoteClause' })
        } else {
          this.promptFieldCheck()
        }
      })
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 2) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style lang="scss">
.vesselInfo {
  span {
    padding-left: 10px;
  }
}
</style>
